import request from '@/utils/request'

function QUERY( {key, params}) {
  let show_loading = true;
  let url
  // 小程序授权登录
  if(key=='getSappLoginToken'){
    url = '/h5/Login/getSappLoginToken'
  }
  // 小程序底部菜单-客户消息、预警未读消息数
  if(key=='getSappMenuInfo'){
    url = '/h5/CommonParameter/getSappMenuInfo'
    show_loading = false;
  }
  // 埋点接口
  if(key=='inH5Record'){
    url = '/h5/PageRecord/inH5Record';
    show_loading = false;
  }
  // 缺省页判断接口
  if(key=='getAccountInfo'){
    url = '/h5/CommonParameter/getAccountInfo';
    show_loading = false;
  }
  // '立即续费'弹窗判断
  if(key=='renew'){
    url = '/h5/Coupon/renew';
  }
  // 获取jssdk信息接口
  if(key=='GetJsSignPack'){
    url = "/h5/login/getJsSignPack";
  }
  // 获取旺旺昵称接口
  if(key=='getBuyerNick'){
    url = '/h5/CommonParameter/getBuyerNick';
  }
  
  if (typeof params == 'object') {
    params['version'] = 'MINI'
  } else {
    params = { version: 'MINI' }
  }
  return request({
    url,
    method: 'post',
    show_loading,
    params
  })
}

export default QUERY;